import { render } from "./BaseChart.vue?vue&type=template&id=060e503a"
import script from "./BaseChart.vue?vue&type=script&lang=js"
export * from "./BaseChart.vue?vue&type=script&lang=js"
script.render = render

export default script